import React from "react";
import { Link } from "react-router-dom";

export default function CancelPage() {
  return (
    <main
      data-testid="cancel-page-root"
      className="min-h-screen bg-[#F9F8F6] text-[#0B192C] flex items-center justify-center px-6"
    >
      <div className="max-w-xl text-center">
        <p className="overline">Ordine annullato</p>
        <h1 className="font-serif-display text-4xl md:text-6xl mt-4 leading-tight">
          Hai cambiato rotta.
        </h1>
        <p className="mt-6 text-[#3A4F6B] text-lg font-light">
          Nessun addebito è stato effettuato. Quando vorrai, il libro sarà ancora qui ad attenderti.
        </p>
        <Link
          to="/"
          data-testid="cancel-back-home"
          className="inline-block mt-10 px-8 py-4 bg-[#0B192C] text-[#F9F8F6] text-sm uppercase tracking-[0.2em] hover:bg-[#1E3557] transition-colors"
        >
          Torna alla Home
        </Link>
      </div>
    </main>
  );
}
